import { useEffect, useRef, useState } from "react";

const TONE_COLORS = {
  healthy: "#10b981",
  stretch: "#2563eb",
  risky: "#f59e0b",
  blocked: "#f43f5e",
};

// Semicircular gauge. Score is rendered across gauge.min–gauge.max (from the API).
export default function FitGauge({ score = 0, min = 5, max = 95, label = "", tone = "stretch", testid = "fit-gauge" }) {
  const [display, setDisplay] = useState(0);
  const raf = useRef(null);

  useEffect(() => {
    const start = performance.now();
    const dur = 900;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(score * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [score]);

  const pct = Math.max(0, Math.min(1, (display - min) / (max - min || 1)));
  const R = 80;
  const LEN = Math.PI * R;
  const color = TONE_COLORS[tone] || TONE_COLORS.stretch;

  return (
    <div data-testid={testid} className="flex flex-col items-center">
      <div className="relative w-64 sm:w-80">
        <svg viewBox="0 0 200 118" className="w-full" role="img" aria-label={`DriveClear Fit ${score} percent, ${label}`}>
          <path d="M 20 105 A 80 80 0 0 1 180 105" fill="none" stroke="#e7e5e4" strokeWidth="16" strokeLinecap="round" />
          <path
            d="M 20 105 A 80 80 0 0 1 180 105"
            fill="none"
            stroke={color}
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={`${LEN}`}
            strokeDashoffset={`${LEN * (1 - pct)}`}
            style={{ transition: "stroke-dashoffset 0.1s linear, stroke 0.4s" }}
          />
        </svg>
        <div className="absolute inset-x-0 bottom-1 flex justify-center">
          <span className="text-5xl font-extrabold text-stone-900" data-testid={`${testid}-score`} style={{ fontFeatureSettings: '"tnum" 1' }}>
            {display}%
          </span>
        </div>
      </div>
      <div className="text-lg font-bold mt-1" style={{ color }} data-testid={`${testid}-label`}>{label}</div>
    </div>
  );
}
